import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Logo } from "../brand/Logo";

const LINES = [
  "> powering up care protocol",
  "> linking field · network · intelligence",
  "> online. technology that cares.",
];

const shouldSkip = () =>
  typeof window === "undefined" ||
  window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
  sessionStorage.getItem("tc-booted") === "1";

export const BootSequence = ({ onDone }) => {
  const [visible, setVisible] = useState(() => !shouldSkip());

  useEffect(() => {
    if (!visible) {
      onDone();
      return undefined;
    }
    const t = setTimeout(() => setVisible(false), 2400);
    return () => clearTimeout(t);
  }, [visible, onDone]);

  const skip = () => setVisible(false);

  useEffect(() => {
    if (!visible) sessionStorage.setItem("tc-booted", "1");
  }, [visible]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div key="boot" data-testid="boot-sequence" onClick={skip}
          exit={{ clipPath: "inset(0 0 100% 0)" }} transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-[#0C0A09]" style={{ clipPath: "inset(0 0 0% 0)" }}>
          <div className="tc-grid-bg absolute inset-0 opacity-40" />
          <div className="relative flex flex-col items-center">
            <motion.div initial={{ clipPath: "inset(100% 0 0 0)" }} animate={{ clipPath: "inset(0% 0 0 0)" }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}>
              <Logo className="h-28 w-auto sm:h-36" />
            </motion.div>
            <div className="mt-10 h-[1px] w-56 overflow-hidden bg-white/10">
              <motion.div className="h-full bg-gradient-to-r from-[#C2410C] to-[#FB923C]"
                initial={{ x: "-100%" }} animate={{ x: "0%" }} transition={{ duration: 1.8, ease: [0.65, 0, 0.35, 1] }} />
            </div>
            <div className="mt-6 space-y-1.5 text-center font-mono text-[11px] tracking-[0.12em] text-stone-400">
              {LINES.map((l, i) => (
                <motion.p key={l} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.25 + i * 0.5 }}
                  className={i === LINES.length - 1 ? "text-orange-400" : ""}>{l}</motion.p>
              ))}
            </div>
          </div>
          <button onClick={skip} data-testid="boot-skip-btn"
            className="absolute bottom-8 right-8 rounded-full border border-white/15 px-4 py-2 font-mono text-[11px] uppercase tracking-[0.2em] text-stone-300 transition-colors hover:border-orange-500 hover:text-white">
            Skip intro
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
